import React, { useState } from "react"
import SustainabilityCommunity from "../SustainabilityCommunity/SustainabilityCommunity"
import SustainabilityOurJourney from "../SustainabilityOurJourney/SustainabilityOurJourney"
import { default as BottomBackgroundImage } from "../../../images/eco-sustainability_bg-2.svg"
import "./SustainabilityJourney.scss"
import * as styles from "./SustainabilityJourney.module.scss"

const SustainabilityJourney = ({ productType }) => {
  const [selectedTab, setSelectedTab] = useState(1)

  const ProductInfo = {
    Compostable: {
      color: "#697F6C",
    },
    Recycle: {
      color: "#3A3A6E",
    },
    Reusable: {
      color: "#DE5F72",
    },
  }

  return (
    <div className="noissue__eco-alliance__sustainability__page">
      <div className="noissue__eco-alliance__sustainability__page__container">
        <div
          className="noissue__eco-alliance__sustainability__page__container__heading"
          style={{ color: ProductInfo[productType].color }}
        >
          <h2>Our Sustainability Journey</h2>
          <span>
            Sustainability is one of our core values and present in everything
            we do.
          </span>
        </div>
        <div className="noissue__eco-alliance__sustainability__page__container__tabs">
          <span
            onClick={() => setSelectedTab(1)}
            role="presentation"
            className={`${selectedTab === 1 && "selected"}`}
          >
            Our Journey
          </span>
          <span
            onClick={() => setSelectedTab(3)}
            role="presentation"
            className={`${selectedTab === 3 && "selected"}`}
          >
            Supply Chain
          </span>
          <span
            onClick={() => setSelectedTab(2)}
            role="presentation"
            className={`${selectedTab === 2 && "selected"}`}
          >
            Community
          </span>
        </div>
        {selectedTab === 1 && (
          <SustainabilityOurJourney
            colorCode={ProductInfo[productType].color}
          />
        )}
        {selectedTab === 2 && (
          <SustainabilityCommunity
            tab="Community"
            colorCode={ProductInfo[productType].color}
          />
        )}
        {selectedTab === 3 && (
          <SustainabilityCommunity
            tab="Supply"
            colorCode={ProductInfo[productType].color}
          />
        )}
      </div>
      <div className={styles.bottomBackgroundImageContainer}>
        <img
          src={BottomBackgroundImage}
          className={styles.bottomBackgroundImage}
          alt="bottom-backgound"
          loading="lazy"
        ></img>
      </div>
    </div>
  )
}

export default SustainabilityJourney
